import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, Home, Heart, Mail, Phone, BarChart3, ArrowRight } from 'lucide-react';
import toast from 'react-hot-toast';

const ThankYouPage = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const handleSubmitContact = () => {
    if (!phone.trim() && !email.trim()) {
      toast.error('Veuillez entrer un numéro ou un email');
      return;
    }
    // In a real app, save this contact to the backend
    setSubmitted(true);
    toast.success('Merci ! Vous recevrez les résultats.');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1B5E20 0%, #2E7D32 50%, #388E3C 100%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px', textAlign: 'center' }}>
      <div className="animate-fadeInUp" style={{ maxWidth: '500px' }}>
        <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(255,213,79,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
          <CheckCircle2 size={40} color="#FFD54F" />
        </div>
        
        <h1 style={{ color: 'white', fontSize: '32px', fontWeight: '700', fontFamily: 'Playfair Display, serif', marginBottom: '16px', textShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
          Merci pour votre contribution !
        </h1>
        
        <p style={{ color: '#ffffff', fontSize: '17px', fontWeight: '500', lineHeight: '1.7', marginBottom: '10px' }}>
          Votre avis est précieux pour l'avenir de Khombole.
        </p>
        <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '14px', lineHeight: '1.6', marginBottom: '32px' }}>
          Les résultats de cette enquête seront partagés publiquement lors du Forum citoyen de clôture du mandat.
        </p>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', color: '#FFD54F', marginBottom: '32px' }}>
          <Heart size={16} />
          <span style={{ fontSize: '15px', fontWeight: '600' }}>Ensemble, bâtissons Khombole</span>
        </div>

        {/* Contact form to receive results */}
        {!submitted && !showResults && (
          <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: '16px', padding: '24px', marginBottom: '24px', border: '1px solid rgba(255,255,255,0.15)', textAlign: 'left' }}>
            <h3 style={{ color: 'white', fontSize: '16px', fontWeight: '600', marginBottom: '12px', textAlign: 'center' }}>
              Recevoir les résultats de l'enquête
            </h3>
            <div style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontSize: '12px', color: 'rgba(255,255,255,0.7)', marginBottom: '4px' }}>Numéro WhatsApp</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'rgba(255,255,255,0.1)', borderRadius: '10px', padding: '10px 14px', border: '1px solid rgba(255,255,255,0.15)' }}>
                <Phone size={16} color="rgba(255,255,255,0.5)" />
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Ex: 221771234567"
                  style={{ background: 'transparent', border: 'none', color: 'white', fontSize: '14px', outline: 'none', flex: 1, width: '100%' }}
                />
              </div>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '12px', color: 'rgba(255,255,255,0.7)', marginBottom: '4px' }}>Email</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'rgba(255,255,255,0.1)', borderRadius: '10px', padding: '10px 14px', border: '1px solid rgba(255,255,255,0.15)' }}>
                <Mail size={16} color="rgba(255,255,255,0.5)" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="votre@email.com"
                  style={{ background: 'transparent', border: 'none', color: 'white', fontSize: '14px', outline: 'none', flex: 1, width: '100%' }}
                />
              </div>
            </div>
            <button onClick={handleSubmitContact} style={{ width: '100%', background: 'linear-gradient(135deg, #FFD54F, #FFA000)', color: '#1B5E20', border: 'none', padding: '14px', borderRadius: '12px', fontSize: '15px', fontWeight: '700', cursor: 'pointer' }}>
              M'inscrire pour recevoir les résultats
            </button>
            <button onClick={() => setShowResults(true)} style={{ width: '100%', background: 'transparent', color: 'rgba(255,255,255,0.6)', border: 'none', padding: '10px', fontSize: '13px', cursor: 'pointer', marginTop: '8px' }}>
              Voir les résultats maintenant
            </button>
          </div>
        )}

        {submitted && !showResults && (
          <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: '16px', padding: '24px', marginBottom: '24px', border: '1px solid rgba(255,255,255,0.15)' }}>
            <p style={{ color: '#FFD54F', fontSize: '15px', fontWeight: '600', marginBottom: '8px' }}>Inscription enregistrée !</p>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '13px' }}>Vous recevrez les résultats dès leur publication.</p>
            <button onClick={() => setShowResults(true)} style={{ marginTop: '16px', background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: 'white', padding: '12px 24px', borderRadius: '10px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
              <BarChart3 size={16} style={{ verticalAlign: 'middle', marginRight: '6px' }} />
              Voir un aperçu des résultats
            </button>
          </div>
        )}

        {showResults && (
          <div style={{ background: 'white', borderRadius: '16px', padding: '24px', marginBottom: '24px', textAlign: 'left' }}>
            <h3 style={{ color: '#1B5E20', fontSize: '18px', fontWeight: '700', marginBottom: '16px', textAlign: 'center' }}>
              Aperçu des résultats
            </h3>
            <p style={{ color: '#666', fontSize: '13px', textAlign: 'center', marginBottom: '20px' }}>
              Ces statistiques sont mises à jour en temps réel.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <ResultBar label="Satisfaction générale" value={68} color="#2E7D32" />
              <ResultBar label="Infrastructures" value={52} color="#42A5F5" />
              <ResultBar label="Santé" value={45} color="#FFA726" />
              <ResultBar label="Éducation" value={61} color="#66BB6A" />
              <ResultBar label="Emploi des jeunes" value={38} color="#EF5350" />
            </div>
            <p style={{ color: '#999', fontSize: '11px', textAlign: 'center', marginTop: '16px' }}>
              Données basées sur les réponses collectées à ce jour.
            </p>
          </div>
        )}

        <button onClick={() => navigate('/')} style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: 'white', padding: '14px 32px', borderRadius: '12px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
          <Home size={16} />
          Retour à l'accueil
        </button>

        <div style={{ marginTop: '50px', padding: '16px', background: 'rgba(255,255,255,0.12)', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.2)' }}>
          <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '13px', fontWeight: '500' }}>
            Mairie de Khombole — Département de Thiès — Sénégal
          </p>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '12px', marginTop: '4px' }}>
            magboye.com
          </p>
        </div>
      </div>
    </div>
  );
};

function ResultBar({ label, value, color }) {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
        <span style={{ fontSize: '13px', color: '#333', fontWeight: '500' }}>{label}</span>
        <span style={{ fontSize: '13px', color, fontWeight: '700' }}>{value}%</span>
      </div>
      <div style={{ height: '8px', background: '#eee', borderRadius: '4px', overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${value}%`, background: color, borderRadius: '4px', transition: 'width 0.5s ease' }} />
      </div>
    </div>
  );
}

export default ThankYouPage;
